import { fetchData } from '../utils/async';

export const CLIENT_INIT = 'CLIENT_INIT';
export const SITE_INIT = 'SITE_INIT';
export const CHANGE_DEVICE = 'CHANGE_DEVICE';
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';

export const SUBSCRIBED = 'SUBSCRIBED';
export const SUBSCRIBED_ERROR = 'SUBSCRIBED_ERROR';

/*
	USER SETTINGS
*/
export const changeDevice = (device) => ({ type: CHANGE_DEVICE, device });

export const clientInit = () => ({ type: CLIENT_INIT });

export const changeLanguage = (language) => ({ type: CHANGE_LANGUAGE, language });

/*
	EMAIL
*/

export const subscribeKlaviyo = (email) => (dispatch) => (
	fetchData('klaviyo/subscribe', { email }).then((response) => {
		if (response?.errors) dispatch({ type: SUBSCRIBED_ERROR });
		return dispatch({ type: SUBSCRIBED, data: response });
	}).catch((err) => console.log(err))
);

/*
	INTERACTION EVENTS
*/

export const goToPage = (path) => (dispatch, getState) => {
	const language = getState().environment.setup.language;
	const extra = {};
	const pathSections = path.split('/').reduce((acc, section) => {
		if (section !== '' && section !== language) {
			if (section.indexOf('#') !== -1) {
				extra.hash = section.slice(section.indexOf('#') + 1);
				section = section.slice(0, section.indexOf('#'));
			}
			return [...acc, section];
		}
		return acc;
	}, []);

	if (pathSections.length === 0) {
		return dispatch({ type: 'START', payload: { language } });
	}
	return dispatch({ type: 'CATEGORY_PRODUCT_PAGE', payload: { language, path: pathSections.join('/'), ...extra } });
};
